module.exports = __webpack_public_path__ + "img/__icon_BUS_WINDA.2e181536.svg";